import clsx from "clsx";
import React from "react";

interface FlexProps {
  col?: boolean;
  className?: string;
}

export const Flex: React.FC<FlexProps> = ({
  children,
  col = false,
  className,
}) => {
  return (
    <div className={clsx("flex", col && "flex-col", className)}>{children}</div>
  );
};
